<div class="wrapper">
  <canvas #Doughnut></canvas>
</div>
